import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { deleteShipment, fetchShipments } from '../../../actions/shipmentsActions';
import Button from '../../base/button/index';
import * as StyledModals from '../../myPost/modals/myShipmentsModals.styles';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../../../store';
import { UnknownAction } from 'redux';
import { ShipmentDirection } from '../../../@posturinn/client-react';

const DeleteShipmentModal = ({ shipmentId, onClose, page, modalHeading }) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<ThunkDispatch<RootState, void, UnknownAction>>();
	const [errorMessage, setErrorMessage] = React.useState(null);

	const handleDeleteShipment = async () => {
		try {
			await dispatch(deleteShipment(shipmentId));
			// Wait for deletion to complete, then fetch the updated list
			await dispatch(fetchShipments(page || 1, true, ShipmentDirection.Outbound)); // replace with your actual fetch action
			onClose();
		} catch (err) {
			console.error(err);
			setErrorMessage(t('genericError'));
		}
	};
	const stopPropagation = e => {
		e.stopPropagation();
	};

	return (
		<StyledModals.WrapperV2 onClick={onClose}>
			<StyledModals.ModalOverlay />
			<StyledModals.ModalForm onClick={stopPropagation}>
				<StyledModals.WhiteBox>
					<StyledModals.ModalHeader>
						<div>{modalHeading}</div>
					</StyledModals.ModalHeader>
					{errorMessage && <StyledModals.ErrorMessage>{errorMessage}</StyledModals.ErrorMessage>}
					<StyledModals.ModalActions>
						<Button onClick={onClose}>
							{t('no')}
						</Button>
						<Button primary onClick={handleDeleteShipment}>
							{t('yes')}
						</Button>
					</StyledModals.ModalActions>
				</StyledModals.WhiteBox>
			</StyledModals.ModalForm>
		</StyledModals.WrapperV2>
	);
};

export default DeleteShipmentModal;
